import { CardMedia } from "@mui/material";
import { FC } from "react";
import { config } from "../../config";
import { ServiceRecord } from "../../types/ServiceRecord";
import { Part } from "../../types/Part";
import { Vehicle } from "../../types/Vehicle";
import { User } from "../../types/User";
import { appendQueryParam } from "../../util/helper";

interface Props {
    entity: Vehicle | Part | ServiceRecord | User,
    maxHeight?: number;
}
export const ImageCardView: FC<Props> = ({ entity, maxHeight }) => {
    const image = appendQueryParam(entity.images[config.thumbnailImageIndex], 'updatedAt', entity.updatedAt.toString()) ?? config.defaultVehicleImageUrl;

    return <CardMedia
        component="img"
        height={maxHeight ?? config.gridImageHeight}
        image={image}
        alt="Image N/A"
        style={{ objectFit: image === config.defaultVehicleImageUrl ? 'contain' : 'cover' }}
    />
};